<scf-invest-form
  [title]="'investDetail.title'"
  [subtitle]="'investDetail.subtitle'"
  (consultEvent)="loadDataTable($event)"
  [isDetailAvailable]="true"
></scf-invest-form>

<div *ngIf="data?.length > 0">
  <scf-invest-detail-table *ngFor="let result of data" [data]="result"></scf-invest-detail-table>
</div>

<!-- Comprueba que no se muestre la primera vez -->
<mat-card *ngIf="data?.length === 0 && formData?.valid">
  <mat-card-content>
    <div fxLayout="column" fxLayoutAlign="center center" class="invest-detail__card">
      <mat-label class="panel-request__label-no-operation" translate>investDetail.noOperations</mat-label>
    </div>
  </mat-card-content>
</mat-card>

<div class="panel_footer__buttons" *ngIf="data?.length > 0">
  <div fxFlex="100" fxLayoutAlign="end start" fxLayoutGap="16px">
    <button
      id="createAllExcelPanel"
      mat-stroked-button
      color="accent"
      (click)="createExcel()"
      [disabled]="data?.length === 0"
    >
      <mat-icon class="icon-ic_file_download"></mat-icon>
      <span>{{ 'request.button.excel' | translate | uppercase }}</span>
    </button>
    <button
      id="createAllPdfPanel"
      mat-stroked-button
      color="accent"
      (click)="createPdf()"
      [disabled]="data?.length === 0"
    >
      <mat-icon class="icon-ic_print"></mat-icon>
      <span>{{ 'request.button.print' | translate | uppercase }}</span>
    </button>
  </div>
</div>
